import React from 'react'
import { Box, Flex, Text } from 'rebass/styled-components'
import styled from 'styled-components'
import renderHTML from 'react-render-html'
import { stripHtmlTags } from '../../helpers/Functions'

const TestimonialContainer = styled(Flex)`
    margin: ${(props) => props.theme.space.xxl} auto;
    padding: 0 ${(props) => props.theme.space.md};

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        margin: ${(props) => props.theme.space.xl} auto;
        padding: ${(props) => props.theme.space.xl} ${(props) => props.theme.space[4]} 0;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
        padding: ${(props) => props.theme.space.xl} 0 0;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xxs}) {
        margin: ${(props) => props.theme.space.lg} auto;
        padding-top: ${(props) => props.theme.space.lg};
    }
`

const BorderContainer = styled(Box)`
    max-width: 688px;
    padding-left: ${(props) => props.theme.space.sm};
    padding-right: 0;
    position: relative;
    border-color: ${(props) => props.theme.colors.black};
    border-style: solid;
    border-width: 0 0 0 1px;

    p:first-child {
        margin-top: 0;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        max-width: none;
        padding-right: ${(props) => props.theme.space.md};
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
        border-width: 0;
        padding-left: ${(props) => props.theme.space.sm};
        padding-right: ${(props) => props.theme.space.sm};
    }
`

const Name = styled(Text)`
    font-family: ${(props) => props.theme.fonts.heading};
    font-size: ${(props) => props.theme.fontSizes.xxl};
    font-weight: ${(props) => props.theme.fontWeights.semibold};
    letter-spacing: 2px;
    line-height: 30px;
    margin-top: ${(props) => props.theme.space.md};
    padding-bottom: 0;
`

const Title = styled(Text)`
    font-style: italic;
    line-height: 18px;
    padding-top: ${(props) => props.theme.space.xxs};

    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
        font-style: normal;
    }
`

const TestimonialSingle = ({ options }) => {
    const sanitisedContent = stripHtmlTags(options.content)
    return <TestimonialContainer
        justifyContent="center"
        sx={{
            maxWidth: '1200px',
        }}
    >
        <BorderContainer>
            <Text variant="quote">{renderHTML(sanitisedContent || '')}</Text>
            <Name>{renderHTML(options.author || '')}</Name>
            <Title>{renderHTML(options.authorTitle || '')}</Title>
        </BorderContainer>
    </TestimonialContainer>
}

export default TestimonialSingle
